import styled from "@emotion/styled";
import { Theme, Typography } from "@yuno/design-system-web";

export const Container = styled.div`
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const ToolDescription = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => theme.typography.tiny.regular};
  color: ${({ theme }) => theme.palette.grey[4]};
  margin-bottom: 20px;
`;

export const ToolsContainer = styled.div<{ theme?: Theme }>`
  
`;

export const TitleTools = styled(Typography)<{ theme?: Theme }>`
  margin-bottom: 24px;
  ${({ theme }) => theme.typography.small.bold};
`;

export const RowTool = styled.div<{ theme?: Theme }>`
  display: flex;
  align-items: center;
  gap: 16px;
`;
